import XIndicatorLayout from './index.vue';
export default XIndicatorLayout



// WEBPACK FOOTER //
// ./src/xman/indicator-cause/indicator-layout/index.js